import { useNavigate } from "react-router-dom";
import { ChangeEvent } from "react";
import { permissionCodes, useHasPermission } from "../../permission/hooks";
import { filtersIdMap } from "../../filter/utils";
import Tabbed from "../../_app/layouts/Tabbed";
import { useAllParamValues } from "../../_app/hooks";

interface Props {
  selectedTab: string;
  children: any;
}

function ManageBillingTabBar({ selectedTab, children }: Props) {
  const navigate = useNavigate();
  const periods = useAllParamValues(
    selectedTab === "service-analysis" ? filtersIdMap?.SERVICES_BILL_PERIOD : filtersIdMap?.BILL_PERIOD,
  );

  const handleTabChange = (event: ChangeEvent<{}>, value: any) => {
    let path = "/" + value;
    if (periods && periods.length) {
      if (value === "service-analysis") {
        const params = new URLSearchParams();
        periods.forEach((period) => params.append(filtersIdMap?.SERVICES_BILL_PERIOD, period));
        const query = params.toString();
        if (query) path += `?${query}`;
      } else if (periods[0] !== "UNBILLED") {
        const params = new URLSearchParams();
        periods.forEach((period) => params.append(filtersIdMap?.BILL_PERIOD, period));
        const query = params.toString();
        if (query) path += `?${query}`;
      }
    }
    navigate(path);
  };

  const hasPermissionToUsage = useHasPermission(permissionCodes.BILLING_MANAGE);

  return (
    <Tabbed
      selectedTab={selectedTab}
      handleTabChange={handleTabChange}
      tabs={[
        {
          value: "bills",
          label: "Bill Summary",
          hidden: false,
        },
        {
          value: "usage-analysis",
          label: "Usage Analysis",
          hidden: !hasPermissionToUsage,
        },
        {
          value: "service-analysis",
          label: "Service Analysis",
          hidden: false,
        },
      ]}
    >
      {children}
    </Tabbed>
  );
}

export default ManageBillingTabBar;
